export default __webpack_public_path__ + "static/media/sleep_maker_movie.1b7a5174.gif";